import { createFileRoute, redirect } from '@tanstack/react-router'

import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'
import { UserManualPage } from '@/shared/components/user-manual'

// User manual — opens via the avatar dropdown. Available to any
// authenticated dashboard role; the mobile-only field officer role is
// redirected away, matching how /profile is gated.
export const Route = createFileRoute('/manual')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (!state.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    const role = state.user?.role_name
    if (role === 'field_officer') {
      throw redirect({ to: postLoginRedirect(role) })
    }
  },
  component: UserManualPage,
})
